import { render, staticRenderFns } from "./MedicinePackage.vue?vue&type=template&id=7c08b8cb"
import script from "./MedicinePackage.vue?vue&type=script&lang=js"
export * from "./MedicinePackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports